var React = require( 'react' );
var createReactClass = require('create-react-class');

var VideoEditor = createReactClass( {
    handleChange: function(e) {
        this.props.handleChange(e, this.props.videoFieldName);
    },

	render: function () {
        const { video } = this.props;
        return (
            <div>
                <h3>Video settings</h3>
                <div className="input-field">
                    <label htmlFor="video-title" className="heading">Title</label>
                    <input type="text" id="video-title" name="title" defaultValue={video && video.title} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="video-description" className="heading">Description</label>
                    <input type="text" id="video-description" name="description" defaultValue={video && video.description} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="video-thumbnail" className="heading">Thumbnail</label>
                    <input type="text" id="video-thumbnail" name="thumbnail" defaultValue={video && video.thumbnail} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="video-female-mp4" className="heading">Female MP4</label>
                    <input type="text" id="video-female-mp4" name="female_mp4" defaultValue={video && video.female_mp4} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="video-female-url" className="heading">Female video URL</label>
                    <input type="text" id="video-female-url" name="female_url" defaultValue={video && video.female_url} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="video-male-mp4" className="heading">Male MP4</label>
                    <input type="text" id="video-male-mp4" name="male_mp4" defaultValue={video && video.male_mp4} onChange={(e) => this.handleChange(e)} />
                </div>
                <div className="input-field">
                    <label htmlFor="video-male-url" className="heading">Male video URL</label>
                    <input type="text" id="video-male-url" name="male_url" defaultValue={video && video.male_url} onChange={(e) => this.handleChange(e)} />
                </div>
            </div>
        );
	}
});

module.exports = VideoEditor;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/videoEditor.jsx